module.exports = __webpack_public_path__ + "img/gb9116_10.prt.38621b71.jpg";